import React, {useContext, useEffect, useState} from 'react';
import {Button, Col, ConfigProvider, DatePicker, DatePickerProps, Form, Input, Modal, Row, Select} from 'antd';
import Colors from "../../../../styles/Colors";
import {BiCheck, BiX} from "react-icons/bi";
import locale from "antd/es/locale/es_ES";
import {AuthContext} from "../../../../config/AuthContext";
import {PostLlistatsPdf} from "../../../../dao/multilleure/casals/PostLlistatsPdf";
import dayjs, {Dayjs} from "dayjs";

interface IngredientModalProps {
    element: object;
    visible: boolean;
    llistes: [];
    escolesList: [];
    extresList: [];
    onClose: (value: boolean) => void;
    editar?: boolean;
}

const InscripcionsDescarregar: React.FC<IngredientModalProps> = ({element, visible, onClose, editar, extresList, llistes, escolesList}) => {
    const [form] = Form.useForm();
    const {isLoggedIn, userId, user, page} = useContext(AuthContext);
    const [documentUrlPdf, setDocumentUrlPdf] = useState<string | undefined>("");

    const [escoles, setEscoles] = useState(false);
    const [extres, setExtres] = useState(false);
    const [setmanes, setSetmanes] = useState(false);
    const [salts, setSalts] = useState(false);
    const [mides, setMides] = useState('0');

    useEffect(() => {

    }, [element]);

    async function handleSubmit() {
        const formData = form.getFieldsValue();
        const newFormData = {...formData, escoles: escoles, salts: salts, mides: mides, setmanes: setmanes, extres: extres};
        //console.log("Form Data:", newFormData);
        //console.log(JSON.stringify(newFormData));

        const documentUrl = await PostLlistatsPdf(newFormData, page);
        setDocumentUrlPdf(documentUrl);

        if (documentUrl && documentUrl !== "") {
            const link = document.createElement('a');
            link.href = documentUrl;
            link.download = `Llistat.pdf`;
            link.target = '_blank';
            link.style.display = 'none';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }

        //onClose(false);
    };

    const handleCancel = () => {
        onClose(false);
    };

    function changeLlistat(value: any) {
        llistes.find((value1: any, index) => {
            if (value1.value === value) {
                setEscoles(value1.escoles);
                setExtres(value1.extres);
                setSalts(value1.salts);
                setMides(value1.mides);
                setSetmanes(value1.setmanes);
            }
        })
    }

    const weekFormat = 'DD/MM';

    const customWeekStartEndFormat: DatePickerProps['format'] = (value) =>
        `${dayjs(value).startOf('week').format(weekFormat)} ~ ${dayjs(value)
            .endOf('week')
            .format(weekFormat)}`;


    return (
        <ConfigProvider locale={locale}>
            <Modal
                title="Editar Ingrediente"
                open={visible}
                onCancel={handleCancel}
                footer={[]}
                width={500}
            >
                <Form form={form} initialValues={element} onFinish={handleSubmit}>
                    <hr/>
                    <Row gutter={[16, 16]}>
                        <Col span={24}>
                            <Form.Item label="ID activitat" name="id">
                                <Input disabled/>
                            </Form.Item>
                            <Form.Item label="Llistat" name={"llistat"}
                                       rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                                <Select showSearch
                                        placeholder="Selecciona Llistat"
                                        optionFilterProp="children"
                                        onChange={changeLlistat}
                                        options={llistes}
                                />
                            </Form.Item>
                            <Form.Item label="Casals" name={"id_casal"} hidden={!escoles}
                                       rules={[{required: escoles, message: 'Aquest camp es obligatori'}]}>
                                <Select showSearch
                                        placeholder="Selecciona Llistat"
                                        optionFilterProp="children"
                                        options={escolesList}
                                />
                            </Form.Item>
                            <Form.Item label="Extres" name={"id_extra"} hidden={!extres}
                                       rules={[{required: extres, message: 'Aquest camp es obligatori'}]}>
                                <Select showSearch
                                        placeholder="Selecciona Llistat"
                                        optionFilterProp="children"
                                        options={extresList}
                                />
                            </Form.Item>
                            <Form.Item label="Setmana" name={"setmana"} hidden={!setmanes}
                                       rules={[{required: setmanes, message: 'Aquest camp es obligatori'}]}>
                                <DatePicker
                                    format={customWeekStartEndFormat}
                                    picker="week"
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    <hr/>
                    <Row gutter={[16, 16]}>
                        <Col span={4}>
                        </Col>
                        <Col span={2}>
                            <Form.Item>
                                <Button title={"Aceptar"} htmlType={"submit"}
                                        style={{backgroundColor: Colors.colors.color6}}><BiCheck/></Button>
                            </Form.Item>
                        </Col>
                        <Col span={4}>
                        </Col>
                        <Col span={2}>
                            <Button title={"Cancelar"} style={{backgroundColor: Colors.colors.color1}}
                                    onClick={handleCancel}><BiX/></Button>
                        </Col>
                    </Row>
                </Form>
            </Modal>
        </ConfigProvider>
    );
};

export default InscripcionsDescarregar;
